import styled from 'styled-components';

export const LogoWrapper = styled.div`
  position: absolute;
  top: ${(props) => props.theme.spacing[8]};
  right: ${(props) => props.theme.spacing[8]};
  height: 20px;
  max-width: 100%;

  @media ( max-width: ${(props) => props.theme.screen.md} ) {
    right: ${(props) => props.theme.spacing[48]};
  }

  @media ( max-width: ${(props) => props.theme.screen.sm} ) {
    position: relative;
    top: 0;
    right: 0;
  }
`;
